const WALLET_ICONS_BASE = '/walleticons';

const WALLET_ICON_BY_VALUE = {
  Tron: 'Tron.png',
  tron: 'Tron.png',
  binancepay: 'Binancepay.png',
  eth: 'eth.png',
  polygon: 'polygon.webp',
  bsc: 'BSC.png',
  kucoinpay: 'kucoin.png',
  sepolia: 'sepolia.png',
  amoy: 'amoy.webp',
  bsctestnet: 'BSCTestnet.webp',
  nile: 'nile.png',
};

const WALLET_ICON_RULES = [
  { match: /tron\s*nile|\bnile\b/i, file: 'nile.png' },
  { match: /bnb\s*smart\s*chain\s*testnet|bsctestnet/i, file: 'BSCTestnet.webp' },
  { match: /ethereum\s*sepolia|\bsepolia\b/i, file: 'sepolia.png' },
  { match: /polygon\s*amoy|\bamoy\b/i, file: 'amoy.webp' },
  { match: /tron|trc-?20/i, file: 'Tron.png' },
  { match: /binance\s*pay|binancepay/i, file: 'Binancepay.png' },
  { match: /ethereum|erc-?20|\beth\b/i, file: 'eth.png' },
  { match: /polygon|matic/i, file: 'polygon.webp' },
  { match: /bnb|bep-?20|\bbsc\b/i, file: 'BSC.png' },
  { match: /kucoin/i, file: 'kucoin.png' },
  { match: /bitcoin|\bbtc\b/i, file: 'Bitcoin.png' },
];

export const resolveWalletIconUrl = ({ title = '', value = '' } = {}) => {
  const normalizedValue = value?.toString().trim();
  if (normalizedValue) {
    const file =
      WALLET_ICON_BY_VALUE[normalizedValue] ||
      WALLET_ICON_BY_VALUE[normalizedValue.toLowerCase()];
    if (file) return `${WALLET_ICONS_BASE}/${file}`;
  }

  const name = title.toString().trim();
  if (!name) return '';

  const rule = WALLET_ICON_RULES.find((entry) => entry.match.test(name));
  return rule ? `${WALLET_ICONS_BASE}/${rule.file}` : '';
};
